import instrumentUrl from '../assets/VSS_Final3b.glb';
import logoUrl from '../assets/Logo.glb';
import setUrl from '../assets/Set.glb';

/**
 * Every file the scene is built from, in one place, so the loader pulls in
 * exactly what the components go on to ask their loaders for.
 *
 * Nothing here is preloaded at import time on purpose: the loader fetches these
 * itself to be able to report progress, and a `useGLTF.preload` running
 * alongside it would put the same files on the wire twice.
 */
export const MODELS = {
  logo: logoUrl,
  instrument: instrumentUrl,
  set: setUrl,
} as const;

export const CUBE_PATH = './assets/cubemaps/default/';
export const CUBE_FACES = ['px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'];

/** The faces as the cube loader asks for them, which is how they are cached. */
export const CUBE_URLS = CUBE_FACES.map((face) => CUBE_PATH + face);
